// index.tsx
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SessionTimeoutModal } from '../../components/AppShell/SessionTimeoutModal'
import { RootState } from '../../redux'
import { logoutCmcUser, validateSession } from '../../redux/users/thunks'
import { UserState } from '../../redux/users/slice'

const excludedRoutes = [
  '/'
]

export function SessionTimeoutProvider(
  {
    children
  }: { children: JSX.Element }
) {
  const location = useLocation()
  const dispatch = useDispatch()
  const sessionTimeoutMinutes = useSelector<RootState, number>((state) => state.globalSettings.sessionTimeoutPopupMinutes)
  const user = useSelector<RootState, UserState>((state) => state.user)
  const [TimeoutModalState, setTimeoutModalState] = useState<boolean>(false)

  // TODO: consider hooking the timer to the point where we receive data from the backend
  // Some pages do not send requests to the backend, so we shouldn't reset the timer for those pages.
  useEffect(() => {
    if (excludedRoutes.includes(location.pathname)) {
      setTimeoutModalState(false)
      return () => { /**/ }
    }
    const timeoutMs = sessionTimeoutMinutes * 60 * 1000
    const timeout = setTimeout(() => {
      setTimeoutModalState(true)
    }, timeoutMs)
    return () => clearTimeout(timeout)
  }, [
    location.pathname,
    TimeoutModalState
  ])

  const handleContinueSessionTimeout = () => {
    setTimeoutModalState(false)
    if (
      user.sessionId
      && user.dataCenter
      && user.userId
    ) {
      // Refresh the session
      dispatch(validateSession({
        sessionId: user.sessionId,
        dataCenter: user.dataCenter,
        userId: user.userId
      }))
    }
  }

  const handleLogoutSessionTimeout = () => {
    setTimeoutModalState(false)
    if (user.sessionId && user.dataCenter && user.userId) {
      dispatch(logoutCmcUser({
        sessionId: user.sessionId,
        dataCenter: user.dataCenter,
        userId: user.userId
      }))
    }
  }

  return (
    <>
      { children }
      { TimeoutModalState
        && (
          <SessionTimeoutModal
            open={TimeoutModalState}
            onContinue={() => handleContinueSessionTimeout()}
            onLogout={() => handleLogoutSessionTimeout()}
          />
        )}
    </>
  )
}
